import { partnerClient } from '@modules/core/services';
import { DEFAULT_STUDY_ID } from '../constants';
import { DemographicsParam, DemographicsResponse } from '../types';

export const fetchDemographicsV2 = async ({
  startDate,
  endDate,
  sampleStatus,
  studyId = DEFAULT_STUDY_ID,
}: DemographicsParam): Promise<DemographicsResponse | undefined> => {
  const data = await partnerClient.get(`/studies/${studyId}/metrics/demographics`, {
    params: {
      sampleStatus: sampleStatus?.join(','),
      startDate,
      endDate,
    },
  });

  return data?.data;
};
